import { EventEmitter, Injectable } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpService } from '../../../core/services/http.service';

import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { LocalStorage as SessionStorage } from '../../../core/constants/local-storage';
import { AuthenticationService } from 'src/app/core/services/authentication.service';

/**
 * common library services
 */

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  IsMarried = false;
  toggleSideBar = new Subject<string>();
  newbankInstituteAdded = new Subject<boolean>();

  // private allOpportunity: [];
  // opportunityData = new EventEmitter<any>();
  constructor(
    private httpService: HttpService,
    private http: HttpClient,
    private auth: AuthenticationService
  ) {}

  /**
   * Concatenate url with api end points for micro service
   *
   * @param url url to append with api end points
   *
   * @returns url
   */
  private composeUrl(url: string): string {
    return `${environment.host}/${url}`;
  }

  saveFinancial(formData): Observable<any> {
    return this.httpService
      .post('', `${this.composeUrl('financialGoals/opportunities')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getWelcome(formData): Observable<any> {
    // let data: any = new FormData();
    // data.append("formData", formData);
    return this.httpService
      .get('', `${this.composeUrl('register/welcome')}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  saveApplication(formData): Observable<any> {
    // let data: any = new FormData();
    // data.append("formData", formData);
    return this.httpService
      .post('', `${this.composeUrl('register/contact')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  updateUserSetting(token, formData): Observable<any> {
    return this.httpService
      .put(token, `${this.composeUrl('register/user-setting')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  addNewUser(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('register/add-user')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  addLead(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('client-portal/add-lead')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  addNewClient(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('register/add-client')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  addNewProfessionalAdvisors(token, formData): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('register/add-professional-advisors')}`,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  /**
   * To add new programs
   */
  updatePrivacyConsentDate(token, formData): Observable<any> {
    return this.httpService
      .put(token, `${this.composeUrl('register/privacy-consent-date')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  updateApplication(token, formData): Observable<any> {
    return this.httpService
      .put(token, `${this.composeUrl('register/contact')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getContactDetail(token, id): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('register/contact?contactId=' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getContactSetting(token, id): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('register/user-setting?accountId=' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getallClientfromProfessionalAdvisors(token, id): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('client-portal?contactId=' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getallClientfromAccount(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl('client-portal/from-account?contactId=' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getSystemUserData(token, email): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl('client-portal/get-system-user?email=' + email)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getAdress(token, id): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('register/address?contactId=' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  // not required if we use flow start
  getAllInstitute(token): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('confirm-bank-account/illion-institute')}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getAllAssetData(token, accountId, contactId): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'confirm-current-assets/asset-related-data?accountId=' +
            accountId +
            '&contactId=' +
            contactId
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getAllRelatedInstitute(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'confirm-bank-account/related-institute?contactId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  createCustomer(token, data): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('confirm-bank-account/create-customer')}`,
        data
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  mfaAuthentication(token, data): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('confirm-bank-account/mfa-authentication')}`,
        data
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  addBankFeed(token, data): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('confirm-bank-account/add-bank-feed')}`,
        data
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  addRelatedInstitute(token, data): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('confirm-bank-account/add-related-bank')}`,
        data
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getCustomerData(token, data): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('confirm-bank-account/customer-data')}`,
        data
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  // not required if we use flow end

  getGoals(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl('refinanceConsolidate/goals?opportunityId=' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  saveGoals(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('refinanceConsolidate/goals')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  ///// liability page start      /////
  getLiabilityTypes(token): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'confirm-your-existing-liabilities/getLiabilityTypes'
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getLenders(token): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl('confirm-your-existing-liabilities/getLenders')}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getLendersByName(token, name): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'confirm-your-existing-liabilities/lenders-lookup?name=' + name
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  deleteLiability(token, id): Observable<any> {
    return this.httpService
      .delete(
        token,
        `${this.composeUrl('confirm-your-existing-liabilities/delete/' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getLiabilities(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'confirm-your-existing-liabilities/?accountId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getAllLiabilityData(token, accountId, contactId): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'confirm-your-existing-liabilities/liabilities-related-data?accountId=' +
            accountId +
            '&contactId=' +
            contactId
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  saveLiability(token, formData): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('confirm-your-existing-liabilities/liabilities')}`,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  ///// liability page end      /////

  hitBankFeedFlow(token, data): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('confirm-bank-account/hit-bank-feed-flow')}`,
        data
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  // getBingAddressApi(addressInput): Observable<any> {
  //   var config = {
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Access-Control-Allow-Origin': '*',
  //     },
  //   };
  //   //console.log(config);
  //   //console.log(
  //     `http://dev.virtualearth.net/REST/v1/Autosuggest?query=${addressInput}&countryFilter=au&key=ApdTekiV8XSF2wBK01xq7a6f_3b18Muo6-FkUkewRHF006WlkUZ9714tDjI0RqsL`
  //   );
  //   return this.http
  //     .get(
  //       `http://dev.virtualearth.net/REST/v1/Autosuggest?query=${addressInput}&countryFilter=au&key=ApdTekiV8XSF2wBK01xq7a6f_3b18Muo6-FkUkewRHF006WlkUZ9714tDjI0RqsL`,
  //       config
  //     )
  //     .pipe(catchError(this.handleError<any>('addNewProgram')));
  //   //  ?query=94 the strand&maxResults=10&countryFilter=au&key=ApdTekiV8XSF2wBK01xq7a6f_3b18Muo6-FkUkewRHF006WlkUZ9714tDjI0RqsL
  //   // return this.httpService
  //   //   .get(
  //   //     '',
  //   //     'https://apitest.bankfeeds.com.au/v1/institutions',
  //   //     a,
  //   //     requestOptions
  //   //   )
  //   //   .pipe(catchError(this.handleError<any>('addNewProgram')));
  // }

  getBingAddress(token, data): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('register/bing-address?data=' + data)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getCountries(token): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('register/getCountries')}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  hitDatiumApi(token, data): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('confirm-current-assets/datium')}`, data)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  /**
   * To add new programs
   */
  login(formData): Observable<any> {
    return this.httpService
      .post('', `${this.composeUrl('auth/login')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  loginWithOtp(formData): Observable<any> {
    return this.httpService
      .post('', `${this.composeUrl('auth/login-otp')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  // send otp
  sendOtp(formData): Observable<any> {
    return this.httpService
      .post('', `${this.composeUrl('auth/send-otp')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  /**
   * Forgot Password
   */
  forgotPass(formData): Observable<any> {
    return this.httpService
      .put('', `${this.composeUrl('auth/forgot')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  /**
   * To add new programs
   */
  saveAddress(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('register/address')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  updateAddress(token, formData): Observable<any> {
    return this.httpService
      .put(token, `${this.composeUrl('register/address')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  rapidVOITrigger(token, formData): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('family-profile/rapid-id-voi-flow')}`,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  triggerEmailDocumentFlow(token, formData): Observable<any> {
    return this.httpService
      .put(
        token,
        `${this.composeUrl('review-outstanding-items/document-email-flow')}`,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  updatePasssword(formData): Observable<any> {
    return this.httpService
      .post('', `${this.composeUrl('user/updatePassword')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getUserNotification(
    token,
    contactId: string,
    accountId: string,
    dataLength?: number
  ): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          `user-notification?contactId=${contactId}&accountId=${accountId}&dataLength=${dataLength}`
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  // updateNotification(token, formData): Observable<any> {
  //   return this.httpService
  //     .put(token, `${this.composeUrl('user-notification')}`, formData)
  //     .pipe(catchError(this.handleError<any>('addNewProgram')));
  // }
  addNotification(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('user-notification')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  /*************confirm debt features */

  getDebtFeatures(token, id): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('debt-feature?opportunityid=' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  saveDebtFeature(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('debt-feature')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  /**************retirement plan page */
  saveRetirementPlan(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('retirement-plan')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getRetirementPlan(token, opportunityId): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl('retirement-plan?opportunityId=' + opportunityId)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  // /**************Confirm Identity and Income old version */

  getJobRole(token): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('income/occupation')}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getOccupation(token, name): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('income/occupation-lookup?name=' + name)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getIncomeRelatedData(token, id, contactId): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'income/get-income-related-data?accountId=' +
            id +
            '&contactId=' +
            contactId
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getpartnerDetail(token, id): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('income/partner?accountId=' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getidentityAndIncome(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl('income/identityandincome?contactId=' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getUserAllIncome(token, contactid): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('income/user-income?id=' + contactid)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getPartnerEmploymentDetails(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'income/partner-employment-details?contactId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getPartnerIdentityAndIncome(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl('income/partner-identity-and-income?id=' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getIncomeType(token): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('income/incomeType')}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  // abn lookup
  getCompanies(token, companyName): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl('income/companies?companyName=' + companyName)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  // ownership structure lookup
  getCRMCompanies(token, companyName): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'income/ownership-structure-companies?companyName=' + companyName
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getDocumentType(token, documentTypename): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'review-outstanding-items/documentTypename?documentTypename=' +
            documentTypename
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  // acn lookup
  // // getACNCompanies(token, companyName): Observable<any> {
  // //   return this.httpService
  // //     .get(
  // //       token,
  // //       `${this.composeUrl('income/acn-companies?companyName=' + companyName)}`
  // //     )
  // //     .pipe(catchError(this.handleError<any>('addNewProgram')));
  // // }

  getSuperannuation(token, name): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'confirm-current-assets/superannuation?superannuation=' + name
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  saveIdentityAndIncome(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('income')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  addSecondaryUser(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('income/add-secondary-user')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  saveIdentityAndIncomeForPopup(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('income/popup')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  saveOtherIncome(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('income/otherIncome')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  updateUserIncome(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('income/update-user-income')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  saveSuperfund(token, formData): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('confirm-current-assets/superfund')}`,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  // saveIncomeToAsset(token, formData): Observable<any> {
  //   return this.httpService
  //     .post(
  //       token,
  //       `${this.composeUrl('confirm-current-assets/income-to-asset')}`,
  //       formData
  //     )
  //     .pipe(catchError(this.handleError<any>('addNewProgram')));
  // }
  deleteIncome(token, id): Observable<any> {
    return this.httpService
      .delete(
        token,
        `${this.composeUrl('confirm-current-assets/delete-income/' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  saveCompany(token, formData): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('confirm-holding-structures/company')}`,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  bindAssetToInsurance(token, formData): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('confirm-current-assets/bind-insurance')}`,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  savePartnerIdentityAndIncome(token, formData): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('income/partner-identity-and-income')}`,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  savePartnerIdentityAndIncomeForPopup(token, formData): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('income/partner-identity-and-income/popup')}`,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  deleteSalary(token, id): Observable<any> {
    return this.httpService
      .delete(token, `${this.composeUrl('income/salary/' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  saveFamilyRelationship(token, formData): Observable<any> {
    // console.log('form, data in user service');
    // console.log(formData);
    return this.httpService
      .post(token, `${this.composeUrl('familyrelationship')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getFamilyRelationship(token, id): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('familyrelationship?contactId=' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  deleteFamilyRelationship(token, id): Observable<any> {
    return this.httpService
      .delete(token, `${this.composeUrl('familyrelationship/' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getExistingLiabilities(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl('confirm-monthly-expense?contactId=' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  postExistingLiabilities(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('confirm-monthly-expense')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  deleteExpense(token, id): Observable<any> {
    return this.httpService
      .delete(
        token,
        `${this.composeUrl('confirm-monthly-expense/delete/' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  putExistingLiabilities(token, formData): Observable<any> {
    return this.httpService
      .put(token, `${this.composeUrl('confirm-monthly-expense')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  // postOtherExpenses(token, formData): Observable<any> {
  //   return this.httpService
  //     .post(
  //       token,
  //       `${this.composeUrl('confirm-monthly-expense/other-expense')}`,
  //       formData
  //     )
  //     .pipe(catchError(this.handleError<any>('addNewProgram')));
  // }

  SaveOtherExpenses(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('confirm-other-expense')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  updateOtherExpenses(token, formData): Observable<any> {
    return this.httpService
      .put(token, `${this.composeUrl('confirm-other-expense')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getOtherExpenses(token, id): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('confirm-other-expense?contactId=' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getLandingFlags(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl('credit-file-review/landing-flags?contactId=' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  // getCreditSummary(token, id): Observable<any> {
  //   return this.httpService
  //     .get(token, `${this.composeUrl('debt/credit-summary?accountId=' + id)}`)
  //     .pipe(catchError(this.handleError<any>('addNewProgram')));
  // }

  getRecentCredit(token, id): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('debt/credit-enquiries?accountId=' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getDebtStrategies(token, id): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('debt/debt-Strategies?accountId=' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getRepaymentHistory(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'credit-file-review/repayment-history?contactId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  postOtherExpensesInBulk(token, formData): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('credit-file-review/other-expenses')}`,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  deleteOtherExpense(token, id): Observable<any> {
    // console.log('in service delete');
    // console.log(id);
    return this.httpService
      .delete(
        token,
        `${this.composeUrl('credit-file-review/other-expenses/' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  // deleteRepaymentHistory(token, id): Observable<any> {
  //   //console.log('in service delete');
  //   //console.log(id);
  //   return this.httpService
  //     .delete(
  //       token,
  //       `${this.composeUrl('credit-file-review/repayment-history/' + id)}`
  //     )
  //     .pipe(catchError(this.handleError<any>('addNewProgram')));
  // }
  // getLiabilities(token, id): Observable<any> {
  //   return this.httpService
  //     .get(
  //       token,
  //       `${this.composeUrl('refinanceConsolidate/liabilities?contactId=' + id)}`
  //     )
  //     .pipe(catchError(this.handleError<any>('addNewProgram')));
  // }
  getBankAccountDetail(token, id): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('confirm-bank-account?accountId=' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getInvestmentAccount(token, id): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('account-details?investmentId=' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getbankfeedUrlLink(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'confirm-bank-account/get-bank-feed-link?contactId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getAllOwner(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'confirm-bank-account/get-all-owner?contactId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getAllOwnerWithID(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'confirm-bank-account/get-all-owner-with-id?contactId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  postBankAccountDetail(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('confirm-bank-account')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  updateBankAccountDetail(token, formData): Observable<any> {
    return this.httpService
      .put(token, `${this.composeUrl('confirm-bank-account')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  unlinkBank(token, data): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('confirm-bank-account/unlink-bank')}`,
        data
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  deleteLinkedBank(token, data): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('confirm-bank-account/delete-linked-bank')}`,
        data
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  deleteRelatedInstitute(token, id): Observable<any> {
    return this.httpService
      .delete(
        token,
        `${this.composeUrl('confirm-bank-account/delete-related-bank/' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  // getLenders(token): Observable<any> {
  //   return this.httpService
  //     .get(token, `${this.composeUrl('refinanceConsolidate/getLenders')}`)
  //     .pipe(catchError(this.handleError<any>('addNewProgram')));
  // }

  updateBankAccountDetailInBulk(token, formData): Observable<any> {
    return this.httpService
      .put(
        token,
        `${this.composeUrl('confirm-bank-account/in-bulk')}`,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  deleteBankAccountDetail(token, id): Observable<any> {
    return this.httpService
      .delete(token, `${this.composeUrl('confirm-bank-account/' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  deleteBankInvitations(token, id): Observable<any> {
    return this.httpService
      .delete(
        token,
        `${this.composeUrl('confirm-bank-account/bank-invitations/' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getSareHolders(token, payload): Observable<any> {
    return this.http
      .post(
        ` https://prod-20.australiasoutheast.logic.azure.com:443/workflows/c36efed0c5f3451f8aa99d34c0e88f34/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=W-LJTRI027aEse-5ckj7buVLiJiU2c4XHH9IQBiAQsk`,
        payload
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getInsuranceRelateddata(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'confirm-your-insurance/insurance-releted-data?accountId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getInsuranceProvider(token): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl('confirm-your-insurance/getInsuranceProvider')}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getCurrentInsurance(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl('confirm-your-insurance?accountId=' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  postCurrentInsurance(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('confirm-your-insurance')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  postSingleInsurance(token, formData): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('confirm-your-insurance/single-insurance')}`,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  deleteCurrentInsurance(token, id): Observable<any> {
    return this.httpService
      .delete(token, `${this.composeUrl('confirm-your-insurance/' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getVehicleMaker(token, VehicleType): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'confirm-current-assets/get-vehicle-maker?type=' + VehicleType
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getVehicleModel(token, VehicleType): Observable<any> {
    //  //console.log('coming into service getVehicleModel');
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'confirm-current-assets/get-vehicle-model?type=' + VehicleType
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getFundType(token): Observable<any> {
    // //console.log('coming into service get fund type');
    return this.httpService
      .get(token, `${this.composeUrl('confirm-current-assets/get-fund-type')}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getInvestmentPlatform(token): Observable<any> {
    // //console.log('coming into service get fund type');
    return this.httpService
      .get(
        token,
        `${this.composeUrl('confirm-current-assets/Investment-platform')}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getExistingAsset(token, id): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('confirm-current-assets?acountId=' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getInvestmentHoldings(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'account-details/investment-holding?contactId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getHoldingsByInvestmentAccountId(token, id): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('investment-and-superannuation/holdings')}`,
        id
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getBeneficiaryByInvestmentAccountId(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'investment-and-superannuation/beneficiary?investmentAccountId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getPerformanceChart(token, id, date): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('investment-and-superannuation/performance-chart')}`,
        { id, date }
      )

      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getAnnualReportData(token, id): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('investment-and-superannuation/annual-report')}`,
        id
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  deleteInvestmentHolding(token, id): Observable<any> {
    return this.httpService
      .delete(
        token,
        `${this.composeUrl('account-details/investment-holding/' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getAssetForInsurance(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'confirm-current-assets/for-insurance-page?accountId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  postExistingAsset(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('confirm-current-assets')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  postActualIncome(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('income/actual-income')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  deleteExistingAsset(token, id): Observable<any> {
    return this.httpService
      .delete(token, `${this.composeUrl('confirm-current-assets/' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  saveAdvisor(token, data): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('confirm-estate-planner/advisor')}`, data)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getAllAdvisors(token): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl('confirm-estate-planner/professional-advisor')}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  postEstatePlannerDetails(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('confirm-estate-planner')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getEstatePlannerDetails(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl('confirm-estate-planner?accountId=' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  postTaxAgentDetail(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('confirm-tax-agent-details')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getTaxAgentDetail(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl('confirm-tax-agent-details?accountId=' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getTaxAgentDetailByOpportunity(token, id, contactId): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          `confirm-tax-agent-details/specific-agent?oppId=${id}&contactId=${contactId}`
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getRenovationOrCashout(token, id, contactId): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          `confirm-renovation-or-cashout?oppId=${id}&contactId=${contactId}`
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  postRenovationOrCashout(token, formData): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('confirm-renovation-or-cashout')}`,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  /// Buy a property

  getOpportunity(token, id): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('buy-a-property?opportunityId=' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getOpportunityIncome(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl('buy-a-property/income?opportunityId=' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getIncompleteOpportunity(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'financialGoals/incomplete-opportunities?accountId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getUserByID(id: string) {
    return this.httpService
      .get('', `${this.composeUrl('auth/get-user-by-id?contactid=' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getUserByEmail(email: string) {
    return this.httpService
      .get('', `${this.composeUrl('auth/get-user-by-email?email=' + email)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getOpportunityDetail(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl('financialGoals/opportunity?oppId=' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getCompletedOpportunity(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'financialGoals/completed-opportunities?accountId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  postBuyaProperty(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('buy-a-property')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  // confirm-business-finance-need
  postbusinessProperty(token, formData): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('confirm-business-finance-need')}`,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getbusinessProperty(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'confirm-business-finance-need?opportunityId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  postSmsf(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('self-managed-super-fund')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getSmsf(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl('self-managed-super-fund?opportunityId=' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getopportunityData(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'self-managed-super-fund/opportunity?opportunityId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  /// Buy a car/equipment

  getcarEquipment(token, id): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('buy-car-equipment?opportunityId=' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  postCarEquipment(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('buy-car-equipment')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  // complete review and outstanding
  getOutstandingItem(token, id): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('review-outstanding-items?oppId=' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getAllDocumentData(token, oppId, accountId): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'review-outstanding-items/document-related-data?oppId=' +
            oppId +
            '&accountId=' +
            accountId
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getAllOutstandingItem(token, allOppId: string[]): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('review-outstanding-items/all-document')}`,
        allOppId
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getAllCollectedItem(token, accountId: string): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'review-outstanding-items/collected-document?accountId=' + accountId
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getclientAllOutstandingItem(token, accountId: string): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'review-outstanding-items/client-document?accountId=' + accountId
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getWorkInProgress(token, accountId: string): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'financialGoals/work-in-progress?accountId=' + accountId
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  updateOutstandingItem(token, formData): Observable<any> {
    return this.httpService
      .put(token, `${this.composeUrl('review-outstanding-items')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  saveSelectedItems(token, data): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('review-outstanding-items/selected-documents')}`,
        data
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getDirectorship(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'confirm-holding-structures/directorship?accountId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getContactLookup(token, name): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'confirm-holding-structures/contact-lookup?name=' + name
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getCompaniesRelationship(token, name): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'confirm-holding-structures/company-relationship-lookup?name=' + name
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  postDirectorship(token, formData): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('confirm-holding-structures/directorship')}`,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  addSecondaryDirectorship(token, formData): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl(
          'confirm-holding-structures/secondary-directorship'
        )}`,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  deleteDirectorship(token, id): Observable<any> {
    return this.httpService
      .delete(token, `${this.composeUrl('confirm-holding-structures/' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  deleteProfessionalAdvisor(token, id): Observable<any> {
    return this.httpService
      .delete(
        token,
        `${this.composeUrl(
          'confirm-tax-agent-details/professional-advisor/' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getLiabilitiesWithCompanyID(token, companyId): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'confirm-holding-structures/liabilities?companyId=' + companyId
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getFinancialStatements(token, companyId): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'confirm-holding-structures/financial-statement?companyId=' +
            companyId
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  postHoldingStructure(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('confirm-holding-structures')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  inactivateDirectorship(token, formData): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl(
          'confirm-holding-structures/inactivate-directorship'
        )}`,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getCashelTeam(token, id): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('contact-us?accountId=' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  /**
   * Handle error
   * @param string operation
   * @param T result
   */
  handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      const responseCode = error.status;
      if (error.status == '401' || error.statusText == 'Unauthorized') {
        this.auth.logout();
      }
      // if (ResponseCodes.unauthorized.indexOf(responseCode) > -1) {
      //   this.customEventService.dispatchEvent('unAuthorizeEvent', 'logoutUser');
      // }

      return throwError(error);
    };
  }
}
